// ============================================================================
// CropIcon — simple SVG crop icon, Chakra-compatible
// ============================================================================

import { Icon, type IconProps } from '@chakra-ui/react';

export function CropIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M6 2v4H2" />
      <path d="M6 6h12v12" />
      <path d="M18 22v-4h4" />
      <path d="M18 18H6V6" />
    </Icon>
  );
}
